import React from "react";
import PageBanner from "../commoncomponents/Pagebanner";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../index.css";

export default function About() {
  return (
    <>
      <PageBanner title="About Us" />

      <Container className="my-5">
        <Row>
          <Col xs={12} md={5} className="mb-4" data-aos="fade-right">
            <img
              src="/images/Quality Service.png"
              alt="Supplier Verification"
              className="img-fluid"
              style={{
                width: "100%",
                height: "360px",
                objectFit: "contain",
              }}
            />
          </Col>

          <Col xs={12} md={7}>
            <h1
              className="fw-bold"
              data-aos="fade-left"
              style={{ fontSize: "2.4rem" }}
            >
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                Varay QC Services
              </span>
            </h1>
            <p
              data-aos="fade-left"
              style={{
                fontSize: "1.15rem",
                lineHeight: "1.8",
                color: "#333",
              }}
            >
              It is the first independent & professional{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                Quality Assurance / Inspection
              </span>{" "}
              agency dedicated to{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                Buyers’ benefits
              </span>{" "}
              only, with a qualitative service portfolio that includes{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                Product Sourcing
              </span>
              ,{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                3rd Party Quality Inspection
              </span>
              , Supportive Business Services, and Local Support. We assist our
              clients immediately & effectively{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>24×7</span>{" "}
              across India.
            </p>
            <p
              data-aos="fade-left"
              style={{
                fontSize: "1.15rem",
                lineHeight: "1.8",
                color: "#333",
              }}
            >
              With strong management and a highly skilled team,{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                Varay QC Services
              </span>{" "}
              serves clients globally, inspecting products under various
              standards like{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>ISO</span>,{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>EN</span>,{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>ASTM</span>,{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>ANSI</span>,
              and{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>TISI</span>.
            </p>
            <p
              data-aos="fade-left"
              style={{
                fontSize: "1.15rem",
                lineHeight: "1.8",
                color: "#333",
              }}
            >
              Today,{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                Varay QC Services
              </span>{" "}
              is synonymous with{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>trust</span>{" "}
              and{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                quality
              </span>
              .
            </p>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col xs={12}>
            <p
              data-aos="fade-left"
              style={{
                fontSize: "1.15rem",
                lineHeight: "1.8",
                color: "#333",
              }}
            >
              We make international deals smooth & hassle free by acting as the{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                importer’s eyes
              </span>{" "}
              throughout the product lifecycle from{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                sourcing and production to loading
              </span>
              . Whether it’s{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                Quality Assurance
              </span>
              , Research & Development, or local support, we ensure the final
              product meets the client’s{" "}
              <span style={{ fontWeight: "600", color: "#007BFF" }}>
                specific criteria
              </span>
              .
            </p>
          </Col>
        </Row>

        <VisionMission />
      </Container>
    </>
  );
}

function VisionMission() {
  return (
    <Container className="py-5">
      <Row className="g-4">
        <Col xs={12} md={6}>
          <Card className="h-100 shadow-sm">
            <Card.Img
              variant="top"
              src="/images/vission.png"
              alt="Vision"
              className="img-fluid"
              style={{
                objectFit: "cover",
                aspectRatio: "4 / 3",
              }}
            />
            <Card.Body>
              <Card.Title className="fw-bold mb-3">Our Vision</Card.Title>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">
                  Build long-lasting{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    partnerships
                  </span>{" "}
                  based on{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    trust
                  </span>
                  .
                </li>
                <li className="list-group-item">
                  Be a benchmark for{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    quality assurance
                  </span>{" "}
                  in India.
                </li>
                <li className="list-group-item">
                  Provide responsive{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    24×7 support
                  </span>{" "}
                  to global clients.
                </li>
                <li className="list-group-item">
                  Promote{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    ethical business
                  </span>{" "}
                  and transparency.
                </li>
                <li className="list-group-item">
                  Deliver excellence through{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    continuous improvement
                  </span>
                  .
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6}>
          <Card className="h-100 shadow-sm">
            <Card.Img
              variant="top"
              src="/images/Feature_Mission.jpg"
              alt="Mission"
              className="img-fluid"
              style={{
                objectFit: "cover",
                aspectRatio: "4 / 3",
              }}
            />
            <Card.Body>
              <Card.Title className="fw-bold mb-3">Our Mission</Card.Title>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">
                  Earn customers’{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    trust
                  </span>{" "}
                  through{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    exceptional quality
                  </span>
                  .
                </li>
                <li className="list-group-item">
                  Deliver{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    happiness and satisfaction
                  </span>{" "}
                  to every client.
                </li>
                <li className="list-group-item">
                  Build global confidence in{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    Indian products
                  </span>
                  .
                </li>
                <li className="list-group-item">
                  Expand the reach of{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    Indian quality
                  </span>{" "}
                  across the globe.
                </li>
                <li className="list-group-item">
                  Be a{" "}
                  <span style={{ fontWeight: "600", color: "#007BFF" }}>
                    reliable partner
                  </span>{" "}
                  in every business journey.
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
